import script from "./SupplementModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplementModal.vue?vue&type=script&setup=true&lang=js"

import "./SupplementModal.vue?vue&type=style&index=0&id=4ac96c3f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ac96c3f"]])

export default __exports__